import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import t from "../service/translate.service";
import PrimaryTitle from "../components/PrimaryTitle";
import { extendObservable } from "mobx";
import RepairsAndIquiriesStore from "../store/repairsAndInquiries.store";
import { PropTypes } from "prop-types";
import { getAlertInfo } from "../service/alert.service";
import find from "lodash/find";
import withRouter from "../components/withRouter";
import TenantServicesList from "../components/TenantServicesList";
import { StackedNotifications } from "../components/StackedNotifications";
import { Link } from "react-router-dom";
import LoadingPageOverlay from "../components/LoadingPageOverlay";
import { DobInfoModal } from "../components/Dob/DobInfoAlert";

class Welcome extends Component {

  constructor(props, context) {
    super(props);
    extendObservable(this, {
      alerts: this.props.alertStore.alerts,
      schedules: this.props.alertStore.schedules,
      User: this.props.userStore
    });
    this.store = new RepairsAndIquiriesStore();
    this.store.getReports();
    this.loading = false
  }

  openReport = (id) => {
    const selectedReport = this.store.reports.filter((r) => r.id === id)[0];
    this.store.selectedReport = selectedReport;
    this.props.menuStore.setCurrentPage("/repairs-and-inquiries");
    this.props.navigate("/repairs-and-inquiries");
  };

  markAlertRead = (id) => {
    this.alerts = this.alerts.filter((a) => a.id !== id);
  };

  onClick = (link) => {
    this.props.menuStore.setCurrentPage(link);
  };
   navigateToPage(type, status){
    if(type === 'letter') this.props.navigate('/letters')
    if(type === 'oc_inspection') this.props.navigate('/receipt-inspection')
    if(status === 'emailVerification') this.props.navigate('/contracts')
    if(status === 'voucher_eligibility') this.props.navigate('/vouchers')
  }

  componentDidMount() {
    (async () => {
      this.loading = true
      await this.User.loadUser()
      await this.props.contractStore.initContracts()
      await this.props.alertStore.getAllAlerts()
      this.loading = false
    })()
  }

  render() {
    const hasPending = Boolean(
      find(this.User.contracts, (c) => !c.valid && c.active)
    );
    const { alerts, markAlertRead, markAllAlertsRead } = this.props.alertStore;

    return (
      <div>
        {this.loading && (
          <LoadingPageOverlay />
        )}
        <PrimaryTitle title={t.WELCOME_TITLE} aria-level="1" role="heading" />

        <div className="homepage">
          {this?.User?.haveContractToSign && (
            <div className="contract-sign-warning">
              <p>{t.CONTRACT_SIGN_WARNING_1} <Link to='/contract-sign'>{t.CONTRACT_SIGN_WARNING_2}</Link>{t.CONTRACT_SIGN_WARNING_3}</p>
            </div>
          )}
          {this?.User?.showDobProvideModal && (
            <div className="dob-provide-info-wrapper">
              <DobInfoModal user={this.User} />
            </div>
          )}
          <section>
            {alerts && alerts.some((alert) => !alert.seen && !alert?.content?.includes('<p hidden>long</p>')) && (
              <div className="clear-all-notifications-holder">
                <Link
                  onClick={() => markAllAlertsRead()}
                  className="clear-all-notifications-btn"
                  aria-label={t.CLEAR_NOTIFICATIONS}
                >
                  {t.CLEAR}
                </Link>
              </div>
            )}
            <StackedNotifications
              notifications={alerts.map((alert, index) => {
                const { sName, content } = getAlertInfo(alert);
                return { ...alert, content, sName, setDangerously: true };
              })}
              onClose={markAlertRead}
              onContentClick={(alert) => this.navigateToPage(alert.type, alert.status)}
              aria-live="polite"
            />
            {hasPending && (
              <article className="item notification-group" key="0">
                <div className="notification">
                  <div className="content">
                    <h2 style={{ fontFamily: "parka-bold", fontSize: "unset" }} role="heading" aria-level="2">
                      {t.PENDING_CONTRACT}
                    </h2>
                    <p>{t.PENDING_CONTRACT_STICKY}</p>
                  </div>
                </div>
              </article>
            )}
          </section>

          <div className="text-center">
            <h2 className="title secondary" role="heading" aria-level="2">
              {t.QUICK_LINKS}
            </h2>
          </div>

          <TenantServicesList
            onClick={this.onClick}
            User={this.User}
          />
        </div>
      </div>
    );
  }
}

Welcome.propTypes = {
  menuStore: PropTypes.object.isRequired,
  alertStore: PropTypes.object.isRequired,
  contractStore: PropTypes.object.isRequired,
};

export default inject("menuStore", "alertStore", 'contractStore', 'userStore')(withRouter(observer(Welcome)));
